import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Input  } from '@angular/core';
import { SelectOption } from '../model/option.interface';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select-question',
  templateUrl: './select-question.component.html',
  styleUrls: ['./select-question.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectQuestionComponent,
      multi: true
    }
  ]
})
export class SelectQuestionComponent implements OnInit, ControlValueAccessor {

  @Input()
  labelText: string;

  @Input()
  options: SelectOption[];

  @Input()
  disabled: boolean;

  @Input()
  placeholder: string;

  @Input()
  required: boolean;

  @Input()
  submitted: boolean;

  @Input()
  labelWarningGenericText:boolean;

  @Output()
  valueChange = new EventEmitter<any>();

  model: string;
  onChange!: (value: any) => void;
  onTouched!: () => void;

  constructor(private rf: ChangeDetectorRef) { 
    this.model = '';
    this.disabled = false;
    this.labelText = '';
    this.options = [];
    this.placeholder = '';
    this.required = false;
    this.submitted = false;
    this.labelWarningGenericText = false
  }

  writeValue(obj: any): void {
    this.model = obj;
    this.rf.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
    console.log(this.options);
  }

  onOptionSelect(value: any): void {
    if (!this.disabled) {
      this.model = value.toString();
      
      // Notificar cambio para formularios reactivos
      if (this.onChange) {
        this.onChange(value.toString());
      }
      
      // Notificar cambio para formularios template-driven
      this.valueChange.emit(value.toString());
      
      // Marcar como tocado
      if (this.onTouched) {
        this.onTouched();
      }
      
      console.log('value', value.toString());
      this.rf.detectChanges();
    }
  }

  validateText(text: string): boolean {
    const textArray = [
      'No me siento identificado con ninguna de las anteriores',
      'No me siento reconocido con ninguna de estas opciones',
      'No me siento identificado con ninguna de las anteriores',
      'Ninguno de los anteriores',
      'No\nme siento identificado con ninguna de las anteriores',
      'No\nme siento reconocido con ninguna de estas opciones'];
  
    if(textArray.includes(text)){
      return true;
    } 
    return false;
  } 

  validateImage(text: string): boolean {
    const textArray = [
      'No me siento identificado con ninguna de las anteriores',
      'No me siento reconocido con ninguna de estas opciones',
      'Ninguno de los anteriores',
      'No\nme siento identificado con ninguna de las anteriores',
      'No\nme siento reconocido con ninguna de estas opciones'];
  
    if(textArray.includes(text)){
      return false;
    } 
    return true;
  } 
}


